import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, combineLatest, Subject, Subscription } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';
import { ContractOverviewModel, PaginationPage, PaginationResponse } from 'src/app/classes';
import { FormControl } from '@angular/forms';
import { SelectContactComponent } from 'src/app/lib/customer/components/select/select-contact/select-contact.component';
import { ContractService } from '../../../services/contract.service';
import { Contract } from '../../../classes';
import { debounceTime, filter, startWith, switchMap, take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-select-contract-dialog',
  templateUrl: './select-contract-dialog.component.html',
  styleUrls: ['./select-contract-dialog.component.css']
})
export class SelectContractDialogComponent implements OnInit {

  contracts: ContractOverviewModel[] = [];

  formControl: FormControl = new FormControl();

  page: PaginationPage = { 'pageNumber': 1, 'pageSize': 20 };

  total: number = 0;

  private _searching = new BehaviorSubject(false);
  private _searchImmediately = new Subject<void>();
  private _subscriptions: Subscription[] = [];

  constructor(
    private _dialogRef: MatDialogRef<SelectContactComponent>,
    private _contractService: ContractService
  ) { }

  close(){
    this._dialogRef.close();
  }

  contractClicked(contract: Contract){
    this._dialogRef.close(contract);
  }
  
  loadMore(){
    if(!this._searching.value && this.total > this.contracts.length){
      this.page.pageNumber++;
      this._searching.next(true);
      this._contractService
        .searchContractsByString(this.formControl.value, this.page)
        .subscribe((result) => this.searchCallback(result));
    }
  }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.setInitialIssues();
    this.contracts = [];
    this._subscriptions.push(...[
      combineLatest([this.formControl.valueChanges.pipe(debounceTime(500)), this._searchImmediately.pipe(startWith([]))]).pipe(filter(_ => !this._searching.value), switchMap(([search]) => {
        this.total = 0;
        this.page.pageNumber = 1;
        this._searching.next(true);
        return this._contractService.searchContractsByString(search, this.page);
      })).subscribe((result: PaginationResponse<ContractOverviewModel[]>) => this.searchCallback(result))
    ])
  }

  search = () => this._searchImmediately.next();
  searchCallback = (result: PaginationResponse<ContractOverviewModel[]>) => {
    if(this.page.pageNumber === 1) this.contracts = [];
    this.contracts.push(...result.content);
    this.total = result.totalItems;
    this._searching.next(false);
  };

  setInitialIssues(){
    this._contractService.contracts$.pipe(take(1), takeUntil(this._searching.pipe(filter(x => x)))).subscribe((contracts: Contract[]) => this.contracts = contracts as any);
  }

}
